var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-carouse-proto"},[_c('div',{ref:"content",staticClass:"preview-carousel-proto__content"},[(_vm.fullHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.fullHtml)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba159d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/preview-carousel-mobile/preview-carousel-mobile.vue
// module id = RzKJ
// module chunks = 0